import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import why from "../assets/Untitled design (5).jpg";

const Why = () => {
  const cards = [
    {
      color: "#ff4da6",
      title: "Where Intelligence Meets Innovation",
      text: "We are a full-spectrum AI solutions company, transforming businesses into smart, self-learning systems. At Foxtroit, we craft AI experiences that empower organizations to predict, automate, and optimize with precision."
    },
    {
      color: "#3399ff",
      title: "Engineering Smart Transformation",
      text: "By combining advanced algorithms, intuitive design, and strategic implementation, we deliver intelligent solutions that drive measurable results. From AI development"
    },
    {
      color: "#33cc99",
      title: "Empowering Growth Through AI",
      text: "Our collaborative approach, deep technical expertise, and commitment to innovation make us a trusted partner for businesses looking to harness the true power of AI."
    }
  ];

  const cardVariants = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", bounce: 0.3, duration: 0.8 },
    },
  };

  return (
    <section
      style={{
        backgroundImage: `url(${why})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        padding: "60px 0",
        color: "#fff",
      }}
    >
      <h1 className="text-center text-dark">
        Why Should You Hire Us
      </h1>
      <Container className="pt-4 pb-4">
        <Row className="g-4 pt-4 pb-4">
          {cards.map((card, idx) => (
            <Col md={4} key={idx} className="pt-4 pb-4 d-flex">
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: false, amount: 0.5 }}
                variants={cardVariants}
                transition={{ delay: idx * 0.2 }}
                className="w-100"
              >
                <Card
                  className="text-center text-white position-relative overflow-hidden w-100 h-100"
                  style={{
                    backgroundColor: "#1a1a1a",
                    borderRadius: "20px",
                    border: "none",
                    borderTop: `10px solid ${card.color}`,
                    minHeight: "350px", // ensures all cards have same minimum height
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}
                >
                  {/* Glow Circle */}
                  <div
                    style={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      backgroundColor: card.color,
                      boxShadow: `0 0 60px 20px ${card.color}`,
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      opacity: 0.2,
                    }}
                  ></div>

                  <Card.Body
                    style={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <Card.Title className="p-4">
                      <h3>{card.title}</h3>
                    </Card.Title>
                    <Card.Text className="px-4 pb-4">{card.text}</Card.Text>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Why;
